module.exports = __webpack_public_path__ + "img/dark-grey-cross.c09cfa6a.svg";